function transformCamelCaseToSnakeCase(value) {
  return value.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
}

export { transformCamelCaseToSnakeCase };
